import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import ar from '@angular/common/locales/ar';
import { registerLocaleData } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-manager-approval-tasks',
  templateUrl: './manager-approval-tasks.component.html',
  styleUrls: ['./manager-approval-tasks.component.scss'],
})
export class ManagerApprovalTasksComponent implements OnInit, OnDestroy {

  private endSub$ = new Subject();
  @Input() tasks: any[] = [];
  lang: string;

  constructor(private translateService: TranslateService) {
    registerLocaleData(ar); // for date pipe
  }

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
    this.handleLangChange();
  }

  private handleLangChange() {
    this.translateService.onLangChange.pipe(takeUntil(this.endSub$)).subscribe((language) => {
      this.lang = language.lang;
    });
  }

  getRols(roles: []) {
    return roles?.join();
  }

  ngOnDestroy(): void {
    this.endSub$.next(null);
    this.endSub$.complete();
  }

}
